import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {fetchCountryList} from "../../../slices/LocationSlice/countrySlice";
import {fetchDivisionList, updateDivisionList} from "../../../slices/LocationSlice/divisionSlice";
import { fetchPincodeList, updatePincodeList } from "../../../slices/LocationSlice/pincodeSlice";
import { fetchOptionListData } from "../../../slices/LocationSlice/optionSlice";
import Pagination from "../../../components/Pagination";
import Loader from "../../../components/Loader";
import EditableTable from "./DivisionTable";
import Modal from "../../../components/Modal";
import ChangeLog from "../../../components/ChangeLog";
import { fetchLanguageList } from "../../../slices/panelSlice/languageSlice";
import AddDivision from "./AddDivision";
import { fetchStateList, setStateId } from "../../../slices/LocationSlice/stateSlice";
import SearchTable from "../../../components/SearchTable";



function Division({editable}) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.state)
  const stateId = useSelector((state) => state.state.stateId)
  const { divisionList, status, error } = useSelector((state) => state.division);
  const country = useSelector((state) => state.countryList);
  const language = useSelector((state) => state.language);
  const optionList = useSelector((state) => state.option);
  const pincodeData = useSelector((state) => state.pincode);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(divisionList?.result)
    ? divisionList?.result?.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = Array.isArray(divisionList?.result)
    ? Math.ceil(divisionList?.result?.length / itemsPerPage)
    : 0;
  const headers =
    divisionList?.result?.length > 0
      ? Object.keys(divisionList.result[0]).filter((key) => key !== "id")
      : [];
  const editableFields = ["title", "status", "code", "val", "optionType","pincode"]; // Define editable fields

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);
  const [addModal, setAddModal] = useState(false);
  

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false); 

  const [searchQuery, setSearchQuery] = useState("")
  const [filteredRows, setFilteredRows] = useState(currentItems);

  useEffect(() => {
    // if (status === "idle") {
    //   dispatch(fetchDivisionList(stateId));
    // }

    if (country?.status === "idle") {
      dispatch(fetchCountryList());
    }

    if (state?.status === "idle") {
      dispatch(fetchStateList());
    }
    if(language?.status === "idle"){
      dispatch(fetchLanguageList());
    }

    if(optionList?.status === "idle"){
      dispatch(fetchOptionListData());
    }
  }, [dispatch,country,state,language, optionList, status]);


  useEffect(()=>{
    if(state.stateList.result){
      dispatch(setStateId(stateId || state.stateList.result[0].id))
      dispatch(fetchDivisionList(stateId || state.stateList.result[0].id));
      dispatch(fetchPincodeList(stateId || state.stateList.result[0].id))
    }
  },[state])

  // if (status === "loading") {
  //   return <Loader></Loader>;
  // }

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = divisionList.result.find((user) => user.id === rowId);
    setEditedData(rowData);
  };

  const handleStateChange = (e)=>{
    dispatch(setStateId(e.target.value));
    dispatch(fetchDivisionList(e.target.value));
  }

  const handleSave = async () => {
    const { id, title, code, optionType, val, status, pincode } = editedData;
    const pincodeId = pincodeData?.pincodeList?.result?.filter((f)=>f.title==pincode)[0]?.id;
    console.log(pincode)
    const optionId = optionList?.optionList?.result?.filter(
      (f) => f.title == optionType
    )[0]?.id;
    const updatedData = { id, title, code, optionType: optionId, val, status,pincode:pincodeId };
    const resp = await dispatch(updateDivisionList(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchDivisionList(stateId));
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field, val) => {
    if (["status", "active"].includes(field)) {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };

  const handleLog = (id) => {
    const logData = divisionList.Change_Log.filter((f) => f.id === id)[0]
      ?.oldTrack;
    setCurrentLog(logData);
    openModal();
  };

  return (
    <div className="w-full flex items-center flex-col">



<div className="w-11/12 items-center justify-between flex mb-2 mt-1">
<div className="w-full flex">
  <div>Division list of</div>
  <select className="ml-2 p-0.5 px-2" name="" id="" value={stateId} onChange={handleStateChange}>
    {state?.stateList?.result?.map((m)=>{
      return <option key={m.id} value={m.id}>{m.title}</option>
    })}
     <option value={'undefined'}>All</option>
  </select>
</div>
<SearchTable
            placeholder="Search for a division..."
            data={currentItems}
            onSearchResults={setFilteredRows} // Update filtered list in parent
            className='m-2'
            allData={divisionList?.result}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
/>
</div>

<div className="max-w-full">

     <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields} // Pass editable fields
        optionList={optionList.optionList}
        languageList={language.data?.result}
        status={status}
        filteredRows={filteredRows}
        pincodeList={pincodeData.pincodeList}
        editable={editable}
        />


        </div>
      <div className="flex mt-4 items-center justify-between w-11/12">
      {searchQuery.length < 3 && <Pagination
  currentPage={currentPage}
  setCurrentPage={setCurrentPage}
  totalPages={totalPages}
/>}

{editable &&   <button
          className="activeBtn text-sm text-white  py-1 px-2 rounded"
          onClick={() => setAddModal(true)}
        >
          + Add Division
        </button>}
      
      </div>






      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog} />}
      />

      <Modal
        isOpen={addModal}
        onClose={() => setAddModal(false)}
        title="Add Division"
        content={
          <AddDivision optionList={optionList.optionList} countryList={country.countryList} stateList={state.stateList} pincodeList={pincodeData.pincodeList} />
        }
      />
      
    </div>
  );
}

export default Division;
